import React from 'react'



function Photography({ content }) {
    return (
        <div>
            <h2>My Photography Portfolio</h2>

            <h4>
                check it out <a href="https://declan.photography" target="_blank" rel="noopener noreferrer">here</a>
            </h4>
            <img src="https://media3.giphy.com/media/5Puwg4f1q4Pm9nfE8w/giphy.gif?cid=ecf05e47k80hgf2e9szsx70wnc4pzcdvtbkeojusumealkl1&ep=v1_gifs_search&rid=giphy.gif&ct=g" alt="Photo gif" style={{ width: '70%' }}>
            </img>

            

        </div>
    )

}

export default Photography
